"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = CreatedByFormatter;

var _react = _interopRequireDefault(require("react"));

var _propTypes = require("../propTypes");

var _Collaborator = require("./Collaborator");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

CreatedByFormatter.propTypes = _propTypes.EditorProps;

function CreatedByFormatter(_ref) {
  var row = _ref.row,
      column = _ref.column;
  var value = row[column.key];
  return value !== null && value !== void 0 && value.firstName ? /*#__PURE__*/_react["default"].createElement(_Collaborator.CollaboratorItem, {
    data: value
  }) : null;
}